import {ON_BANK_LIST} from '../constants/ActionTypes';

const INIT_STATE = {
    bankList: []
};


export default (state=INIT_STATE,action) => {
    switch (action.type){

        case ON_BANK_LIST: {
            return {...state, bankList: action.payload};
        }
        default:
            return state;
    }
}